const regPath = /\/?$/
export function formatPath(path: string) {
  return path.replace(regPath, '')
}
